import type { AvailablePaymentMethod } from '~/modules/GraphQL/types';
import { CustomHeaders, CustomQuery, UseContextReturn } from '~/types/core';

export const getAvailablePaymentMethodsCommand = {
  execute: async (
    context: UseContextReturn,
    cartId: string,
    customQuery?: CustomQuery,
    customHeaders?: CustomHeaders,
  ): Promise<AvailablePaymentMethod[]> => {
    const { data } = await context.app.$vsf.$magento.api.getAvailablePaymentMethods(cartId, customQuery, customHeaders);

    return data?.cart?.available_payment_methods ?? [];
  },
};
